import constants from 'constants/index'

const isActivityAwaitingApproval = (activity) =>
  !activity?.coveredByReview &&
  activity?.status ===
    constants.governanceProjectActivity.AWAITING_APPROVAL_STATUS_ID

export default isActivityAwaitingApproval
